const editTeamEnum = {
    logo: 1,
    joinConditions: 2,
};

Object.freeze(editTeamEnum);

export default editTeamEnum;
